import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    data: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    data(state) {
      return state.data;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertData(state, data) {
      state.data = data;
    },
    saveError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }, payload) {
      try {
        const res = await apiClient.proStatisticsBSchema();
        let schema = res.data;
        let yearsXaxisCat = payload;
        schema.chartOptionsLineYear.xaxis.categories = yearsXaxisCat;

        // let yearActual = new Date().getFullYear();
        // let itemsYear = [];
        // for (let i = 0; i < 20; i++) {
        //   itemsYear[i] = yearActual - i;
        // };
        // schema.statsFormDate.formDateYear.items = itemsYear;

        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadData({ commit, dispatch }, payload) {
      try {
        let modelForm = {};
        if (payload === undefined) {
          const today = new Date();
          let formDateYear = today.getFullYear();
          let formDateMonth = today.getMonth() + 1;
          let formCo = [
            { id: 1, option: 'Co-1' },
            { id: 2, option: 'Co-2' },
            { id: 3, option: 'Co-3' },
            { id: 4, option: 'Co-4' },
            { id: 5, option: 'Co-5' },
          ];
          modelForm.modelStatsDate = { formDateYear, formDateMonth, formCo };
        } else {
          let modelStatsDate = payload.modelForm.modelStatsDate;
          if (modelStatsDate === undefined) {
            const today = new Date();
            let formDateYear = today.getFullYear();
            let formDateMonth = today.getMonth() + 1;
            let formCo = [
              { id: 1, option: 'Co-1' },
              { id: 2, option: 'Co-2' },
              { id: 3, option: 'Co-3' },
              { id: 4, option: 'Co-4' },
              { id: 5, option: 'Co-5' },
            ];
            modelForm.modelStatsDate = { formDateYear, formDateMonth, formCo };
          } else {
            modelForm = payload.modelForm;
          }
        }

        let model = {};
        model.instProfesId = getInstProfesId();
        model.modelForm = modelForm;

        const res2 = await apiClient.modelProStatisticsB(model);
        let data = res2.data.data;
        let dailyTotalData = data?.lineDaily?.[0]?.data || [];

        let dailyXaxisCat = [];
        for (let i = 0; i < Object.keys(dailyTotalData).length; i++) {
          dailyXaxisCat[i] = `${1 + i}`;
        }
        data.dailyXaxisCat = dailyXaxisCat;

        payload = data.yearsXaxisCat;
        dispatch('loadSchema', payload);
        commit('insertData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
